import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Logger } from './logger.service';
import { environment } from '@env/environment';

const ALL_LOCALES_MAP: { [code: string]: string } = {
    'en-ca': 'English',
    'fr-ca': 'Français',
    'nl-qe': 'Dutch',
};

const log = new Logger('I18nService');

@Injectable({
    providedIn: 'root'
})
export class I18nService {
    
    locales!: { [code: string]: string };

    private _selectedLocaleId$!: BehaviorSubject<string>;

    constructor(@Inject(LOCALE_ID) protected localeId: string) {
        this.locales = environment.supportedLanguages.reduce((locales, code) => ({ ...locales, [code]: ALL_LOCALES_MAP[code] }), {});
        log.info(`Initialized for supported languages: '${Object.keys(this.locales).join('\', \'')}'`);

        log.info(`Using '${localeId.toLowerCase()}' from configured app locale`);
        this._selectedLocaleId$ = new BehaviorSubject<string>(localeId.toLowerCase());
    }

    get selectedLocaleId$() { 
        return this._selectedLocaleId$.asObservable(); 
    }

    get selectedLocaleId(): string {
        return this._selectedLocaleId$.getValue();
    }

    get selectedLocale(): string {
        return this.locales[this.selectedLocaleId];
    }

    set selectedLocaleId(selectedLocaleId: string) {
        log.info(`Selecting '${selectedLocaleId}'`);
        if (this._isSupported(selectedLocaleId)) {
            this._selectedLocaleId$.next(selectedLocaleId);
        } else {
            log.error(`'${selectedLocaleId}' does not correspond to a supported language`);
        }
    }

    private _isSupported(code: string): boolean {
        return this.locales.hasOwnProperty(code);
    }
}
